import { useState } from 'react'

import { WeekDays } from '../../DateTime'
import { Component, ComponentProps } from '../Component'
import { controls, numberSize } from '../Controls'

export function WeekDaysUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(numberSize('size'))
  )

  return (
    <>
      <Component {...props.getValues()} Component={WeekDays} name='WeekDays' />
      <ComponentProps name='WeekDays' value={props} onChange={setProps} />
    </>
  )
}
